<!-- RODAPÉ -->
@if (containsFooter) {
  <div class="container">
    <div class="divfacaseucalculo pt-5 mb-5">
      <h2 class="col-8">{{ 'Agora vamos ver como você pode neutralizar' | translate }} {{ 'sua pegada de carbono' | translate }}?</h2>
      <div class="row pt-5">
        <div class="col">
          <a class="btn btn-success text-light" [routerLink]="'./site/calculadora-menu'">{{ 'Faça seu cálculo de carbono' | translate }}</a>
        </div>
        <div class="col pt-3 text-right">
          <a (click)="scrollService.scrollTop()" class="voltaraotopo nav-link">{{ 'Voltar ao topo' | translate }}
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M12 19V5" stroke="#1B3B22" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M5 12L12 5L19 12" stroke="#1B3B22" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </a>
        </div>
      </div>
    </div>
    <hr />
    <!--PARCEIROS-->
    <div class="row pt-4 pb-4 divparceirosrodape">
      <div class="d-flex flex-lg-row flex-column align-items-center gap-5">
        <h2>{{ 'Parceiros' | translate }}</h2>
        <div class="tag-list">
          <div class="loop-slider" style="--duration:16638ms; --direction:reverse;">
            <div class="inner">
              <div class="tag"><img style="width: 30%;" src="./assets/site/parceiros/MaringatechParceiro.png" class="img" /></div>
              <div class="tag"><img src="./assets/site/parceiros/InovainvestParceiro.png" class="img" /></div>
              <div class="tag"><img src="./assets/site/parceiros/SEIMT.png" class="img" /></div>
              <div class="tag"><img src="./assets/site/parceiros/AnjoParceiro.png" class="img" /></div>
              <div class="tag"><img src="./assets/site/parceiros/SindParceiro.png" class="img" /></div>
              <div class="tag"><img src="./assets/site/parceiros/paranavai.jpg" class="img" /></div>
              <div class="tag"><img src="./assets/site/parceiros/IncubadoraParceiro.png" class="img" /></div>
              <div class="tag"><img src="./assets/site/parceiros/SancorParceiro.png" class="img" /></div>
              <div class="tag"><img src="./assets/site/parceiros/hub.jpeg" class="img" /></div>
              <div class="tag"><img src="./assets/site/parceiros/parque.jpeg" class="img" /></div>
              <!-- duplicated content -->
              <div class="tag"><img style="width: 30%;" src="./assets/site/parceiros/MaringatechParceiro.png" class="img" /></div>
              <div class="tag"><img src="./assets/site/parceiros/InovainvestParceiro.png" class="img" /></div>
              <div class="tag"><img src="./assets/site/parceiros/SEIMT.png" class="img" /></div>
              <div class="tag"><img src="./assets/site/parceiros/AnjoParceiro.png" class="img" /></div>
              <div class="tag"><img src="./assets/site/parceiros/SindParceiro.png" class="img" /></div>
              <div class="tag"><img src="./assets/site/parceiros/paranavai.jpg" class="img" /></div>
              <div class="tag"><img src="./assets/site/parceiros/IncubadoraParceiro.png" class="img" /></div>
              <div class="tag"><img src="./assets/site/parceiros/SancorParceiro.png" class="img" /></div>
              <div class="tag"><img src="./assets/site/parceiros/hub.jpeg" class="img" /></div>
              <div class="tag"><img src="./assets/site/parceiros/parque.jpeg" class="img" /></div>
            </div>
          </div>
        </div>
        <!-- <div class="d-flex justify-content-end align-items-center flex-row flex-wrap imgs">
        <img style="width: 30%;" src="./assets/site/parceiros/MaringatechParceiro.png" class="img" />
        <img src="./assets/site/parceiros/InovainvestParceiro.png" class="img" />
        <img src="./assets/site/parceiros/SEIMT.png" class="img" />
        <img src="./assets/site/parceiros/AnjoParceiro.png" class="img" />
        <img src="./assets/site/parceiros/SindParceiro.png" class="img" />
        <img src="./assets/site/parceiros/IncubadoraParceiro.png" class="img" />
        <img src="./assets/site/parceiros/SancorParceiro.png" class="img" />
      </div> -->
    </div>
  </div>
  <!--FIM PARCEIROS-->
  <hr />
  <!--MENUS E REDES SOCIAIS-->
  <div class="container pt-3 pb-3 divmenuredessociais">
    <div class="d-flex">
      <img src="./assets/site/LOGOS/JIANTAN.png" class="logo"/>
      <div class="divredessociais d-flex flex-row flex-wrap justify-content-end">
        <a href="https://www.instagram.com/jiantanbr/?hl=en" class="nav-link">
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
            <path d="M22.6665 2.66699H9.33317C5.65127 2.66699 2.6665 5.65176 2.6665 9.33366V22.667C2.6665 26.3489 5.65127 29.3337 9.33317 29.3337H22.6665C26.3484 29.3337 29.3332 26.3489 29.3332 22.667V9.33366C29.3332 5.65176 26.3484 2.66699 22.6665 2.66699Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M21.3331 15.1604C21.4977 16.2701 21.3081 17.4034 20.7915 18.3991C20.2748 19.3948 19.4573 20.2023 18.4553 20.7066C17.4532 21.211 16.3177 21.3865 15.2102 21.2083C14.1026 21.0301 13.0795 20.5072 12.2862 19.714C11.493 18.9207 10.9701 17.8976 10.7919 16.79C10.6136 15.6825 10.7892 14.5469 11.2935 13.5449C11.7979 12.5429 12.6054 11.7254 13.6011 11.2087C14.5968 10.6921 15.7301 10.5025 16.8398 10.6671C17.9717 10.8349 19.0196 11.3624 19.8287 12.1715C20.6378 12.9806 21.1653 14.0285 21.3331 15.1604Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M23.3335 8.66699H23.3468" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </a>
        <a href="https://br.linkedin.com/company/jiantan" class="nav-link">
          <fa-icon [style]="{width: '32px', height: '32px' }" [icon]="faLinkedin" size="2xl"></fa-icon>
        </a>
        <!-- <li class="nav-item" id="tiktok">
        <a href="" class="nav-link">
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
            <path d="M25.762 7.41625C25.5595 7.31159 25.3624 7.19687 25.1714 7.0725C24.6159 6.70528 24.1066 6.27259 23.6545 5.78375C22.5233 4.48938 22.1008 3.17625 21.9451 2.25688H21.9514C21.8214 1.49375 21.8751 1 21.8833 1H16.7308V20.9237C16.7308 21.1912 16.7308 21.4556 16.7195 21.7169C16.7195 21.7494 16.7164 21.7794 16.7145 21.8144C16.7145 21.8288 16.7145 21.8438 16.7114 21.8587C16.7114 21.8625 16.7114 21.8663 16.7114 21.87C16.6571 22.5849 16.4279 23.2754 16.0441 23.8809C15.6602 24.4864 15.1335 24.9884 14.5101 25.3425C13.8605 25.7121 13.1257 25.906 12.3783 25.905C9.97763 25.905 8.032 23.9475 8.032 21.53C8.032 19.1125 9.97763 17.155 12.3783 17.155C12.8327 17.1546 13.2843 17.2261 13.7164 17.3669L13.7226 12.1206C12.411 11.9512 11.0785 12.0554 9.80911 12.4268C8.53977 12.7981 7.36115 13.4285 6.34763 14.2781C5.45954 15.0498 4.71293 15.9704 4.14138 16.9988C3.92388 17.3738 3.10325 18.8806 3.00388 21.3263C2.94138 22.7144 3.35825 24.1525 3.557 24.7469V24.7594C3.682 25.1094 4.16638 26.3037 4.95575 27.3106C5.59228 28.1183 6.34431 28.8278 7.18763 29.4163V29.4037L7.20013 29.4163C9.6945 31.1112 12.4601 31 12.4601 31C12.9389 30.9806 14.5426 31 16.3639 30.1369C18.3839 29.18 19.5339 27.7544 19.5339 27.7544C20.2686 26.9025 20.8527 25.9318 21.2614 24.8838C21.7276 23.6581 21.8833 22.1881 21.8833 21.6006V11.0306C21.9458 11.0681 22.7783 11.6187 22.7783 11.6187C22.7783 11.6187 23.9776 12.3875 25.8489 12.8881C27.1914 13.2444 29.0001 13.3194 29.0001 13.3194V8.20438C28.3664 8.27313 27.0795 8.07313 25.762 7.41625Z" fill="black" />
          </svg>
        </a>
      </li>
      <li class="nav-item" id="facebook">
        <a href="" class="nav-link">
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
            <path d="M30.6668 3.99974C29.39 4.90037 27.9763 5.58922 26.4802 6.03974C25.6772 5.11642 24.6099 4.46199 23.4229 4.16497C22.2358 3.86795 20.9862 3.94266 19.8429 4.37901C18.6997 4.81535 17.7181 5.59227 17.0308 6.60469C16.3435 7.61711 15.9838 8.81618 16.0002 10.0397V11.3731C13.657 11.4338 11.3352 10.9142 9.24151 9.86033C7.14782 8.80651 5.34725 7.25125 4.00016 5.33307C4.00016 5.33307 -1.33317 17.3331 10.6668 22.6664C7.92087 24.5304 4.64971 25.465 1.3335 25.3331C13.3335 31.9997 28.0002 25.3331 28.0002 9.99974C27.9989 9.62834 27.9632 9.25786 27.8935 8.89307C29.2543 7.55106 30.2146 5.85669 30.6668 3.99974Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </a>
      </li> -->
    </div>
  </div>
  <div class="container footermenus d-flex flex-wrap justify-content-start pt-5">
    <div>
      <h3 class="footer-menu-titles" >{{'Início' | translate}}</h3>
      <mat-list>
        <mat-list-item ><a (click)="scrollHome('home')">Home</a></mat-list-item>
        <mat-list-item ><a (click)="scrollHome('divperguntasfrequentes')">{{'Perguntas frequentes' | translate}}</a></mat-list-item>
        <mat-list-item><a href=""></a></mat-list-item>
      </mat-list>
    </div>
    <div>
      <h3 class="footer-menu-titles">{{'Soluções' | translate}}</h3>
      <mat-list>
        <mat-list-item><a (click)="scrollSolutions('divprodutorruralsolucao')">{{'Bônus de Remoção de Carbono para produtor rural' | translate}}</a></mat-list-item>
        <mat-list-item><a (click)="scrollSolutions('divempresassolucao')">{{'Bônus de Remoção de Carbono para empresas' | translate}}</a></mat-list-item>
        <mat-list-item><a (click)="scrollSolutions('divsindicatosolucao')">{{'Bônus de Remoção de Carbono para sindicatos e cooperativas' | translate}}</a></mat-list-item>
        <mat-list-item><a (click)="scrollSolutions('divselosolucao')">BRC - {{'Selo e certificado de qualidade e transparência' | translate}}</a></mat-list-item>
        <mat-list-item><a (click)="scrollSolutions('divplataformasolucao')">{{'Plataforma' | translate}}</a></mat-list-item>
        <mat-list-item><a (click)="scrollSolutions('divcalcsolucao')">{{'Calcule sua emissão de GEE(gases de efeito estufa)' | translate}}</a></mat-list-item>
        <mat-list-item><a (click)="scrollSolutions('divpalestrasolucao')">{{'Palestras' | translate}}</a></mat-list-item>
      </mat-list>
    </div>
    <div>
      <h3 class="footer-menu-titles">Blog</h3>
      <mat-list>
        <mat-list-item><a href="https://blog.jiantan.com.br/">{{'Conteúdos' | translate}}</a></mat-list-item>
      </mat-list>
    </div>
  </div>
</div>
<!--FIM MENUS E REDES SOCIAIS-->
<hr />
<div class="row pt-4">
  <div class="navbar-nav d-flex flex-md-row flex-column-reverse justify-content-around">
    <div class="divmenurodape d-flex flex-row justify-content-around text-nowrap p-0">
      <a [routerLink]="['/transparencia']" class="nav-link">{{ 'Transparência' | translate }}</a>
      <a [routerLink]="['/termos']" class="nav-link">{{ 'Termos de uso' | translate }}</a>
      <a [routerLink]="['/politica']" class="nav-link">{{ 'Política de privacidade' | translate }}</a>
    </div>
  </div>
</div>
<!--TODOS DIREITOS RESERVADOS-->
<div class="container pl-0 pt-3 pb-3 text-center">
  © 2023 jiantan.com.br - {{ 'Todos os Direitos Reservados' | translate }}.
</div>
<!--FIM TODOS DIREITOS RESERVADOS-->
</div>
}
<!-- FIM RODAPÉ -->
